import { render, staticRenderFns } from "./ProductBestSeller.vue?vue&type=template&id=34c4895d&"
import script from "./ProductBestSeller.vue?vue&type=script&lang=js&"
export * from "./ProductBestSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports